<template>
  <b-row>
    <StepperCol :step="10" />
    <b-col cols="10" md="11" class="pb-4">
      <h5
        class="h3 font-weight-normal mb-4"
        :class="collapsed ? '' : 'text-muted'"
      >
        室内機と室外機は同じ階に設置できますか？
      </h5>
      <b-collapse v-model="shrinking" class="d-md-none">
        <b-button
          variant="outline-warning"
          size="lg"
          class="btn-gd text-left position-relative py-2"
          block
          @click="shrinking = false"
        >
          <span class="h4 m-0">{{
            a0Selected ? "同じ階に設置できる" : a1Selected? "同じ階に設置できない(1階差)" : "同じ階に設置できない(2階差)"
          }}</span>
          <div class="d-block text-muted">
            {{ a0Selected ? "¥0-" : a1Selected? "¥24,200~" : "¥49,500~" }}
          </div>
          <div class="accessory-shrinking">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 12 12"
            >
              <polyline
                fill="none"
                stroke="#FD9000"
                stroke-width="2"
                points="0,6 6,11 12,6"
              />
            </svg>
          </div>
        </b-button>
      </b-collapse>
      <b-collapse v-model="isCollapsed">
        <b-form-row>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left h-145px"
              :class="a0Selected ? 'selected' : ''"
              @click="buttonClicked(0)"
            >
              <h6 class="h4">同じ階に設置できる</h6>
              <b-row no-gutters>
                <b-col
                  cols="4"
                  class="pt-3 d-flex flex-column justify-content-between"
                >
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">0-</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col cols="8" class="d-flex align-items-end">
                  <b-img
                    :src="require('@/assets/images/q-8-1@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="a1Selected ? 'selected' : ''"
              @click="buttonClicked(1)"
            >
              <b-row no-gutters>
                <b-col cols="6" class="pl-3 pt-3">
                  <h6 class="h4">同じ階に設置できない<br />(1階差)</h6>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">24,200~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col
                  cols="6"
                  class="d-flex align-items-end position-relative"
                >
                  <b-img
                    :src="require('@/assets/images/q-8-2@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
          <b-col cols="12" md="6" lg="4" class="mb-3">
            <b-button
              class="btn-gd text-left p-0 h-145px"
              :class="a2Selected ? 'selected' : ''"
              @click="buttonClicked(2)"
            >
              <b-row no-gutters>
                <b-col cols="6" class="pl-3 pt-3">
                  <h6 class="h4">同じ階に設置できない<br />(2階差)</h6>
                  <dl class="text-muted mb-0">
                    <dt>追加工事</dt>
                    <dd class="font-weight-bold h5 mb-0">
                      ¥<span class="h3 ml-1">49,500~</span>
                    </dd>
                  </dl>
                </b-col>
                <b-col
                  cols="6"
                  class="d-flex align-items-end position-relative"
                >
                  <b-img
                    :src="require('@/assets/images/q-8-3@2x.png')"
                    fluid
                  ></b-img>
                </b-col>
              </b-row>
            </b-button>
          </b-col>
        </b-form-row>
      </b-collapse>
    </b-col>
  </b-row>
</template>

<script>
import StepperCol from "../StepperCol";
import { mapState, mapActions } from "vuex";

export default {
  components: {
    StepperCol,
  },
  data() {
    return {
      collapsed: false,
      shrinking: false,
      a0Selected: false,
      a1Selected: false,
      a2Selected: false,
    };
  },
  watch: {
    currentStep(val, old) { // eslint-disable-line
    },
    maxStep(val, old) { // eslint-disable-line
      if (val >= 10) {
        this.collapsed = true;
      }
    },
  },
  computed: {
    ...mapState({
      currentStep() {
        return this.$store.getters.currentStep;
      },
      maxStep() {
        return this.$store.getters.maxStep;
      },
    }),
    isCollapsed: {
      get() {
        if (this.shrinking) {
          if (window.innerWidth < 576) {
            return false;
          } else {
            return true;
          }
        } else {
          return this.collapsed;
        }
      },
      set(value) { // eslint-disable-line
      },
    },
  },
  methods: {
    reset() {
      this.shrinking = false;
      this.collapsed = false;
      this.a0Selected = false;
      this.a1Selected = false;
      this.a2Selected = false;
    },
    ...mapActions({
      doUpdateStep: "doUpdateStep",
      doSaveAnswer: "doSaveAnswer",
    }),
    buttonClicked(value) {
      if (value == 0) {
        this.a0Selected = true;
        this.a1Selected = false;
        this.a2Selected = false;
      } else if (value == 1) {
        this.a0Selected = false;
        this.a1Selected = true;
        this.a2Selected = false;
      } else {
        this.a0Selected = false;
        this.a1Selected = false;
        this.a2Selected = true;
      }
      this.doSaveAnswer({ keyword: 'same_floor', answer: value });
      if (value === 0) {
        this.doUpdateStep(11);
      } else {
        this.doSaveAnswer({ keyword: 'extention_tube', answer: 0 });        
        this.doUpdateStep(12);
      }
      this.shrinking = true;
      if (this.$gtag) {
        console.log("google:室内機と室外機は同じ階に設置できますか？");
        this.$gtag.event("入力", {
          event_category: "選択",
          event_label: "STEP9",
          value: "室内機と室外機は同じ階に設置できますか？",
        });
      }

    },
  },
};
</script>